<div id="main-wrapper" class="oxyy-login-register">
  @if (loadingConfig) {
  <app-loader-full [configInitial]="configInitial"></app-loader-full>
  }@else {
  @if (searchingTicket) {
  <app-loader-full [configInitial]="configInitial"></app-loader-full>
  }
  @if (isMantenimiento) {
  <app-mantenimiento [imgMarca]="configInitial.logo.desktop"></app-mantenimiento>
  }@else {
  <div class="container-fluid px-0">
    <div class="row g-0 min-vh-100">

      <!-- Welcome Text
        ========================= -->
      <div class="col-md-6 col-lg-7 bg-light">
        <div class="hero-wrap d-flex align-items-center h-100">
          <div class="hero-mask opacity-8"></div>
          <div class="hero-bg hero-bg-scroll" style="background-image:url('{{ configInitial.fondo.desktop }}');"></div>
          <div class="hero-content mx-auto w-100 h-100 d-flex justify-content-end flex-column">
            <app-faq [configInitial]="configInitial"></app-faq>
          </div>
        </div>
      </div>
      <!-- Welcome Text End -->

      <!-- Login Form
        ========================= -->
      <div class="col-md-6 col-lg-5 d-flex flex-column align-items-center">
        <div class="container pt-4">
          <div class="row g-0">
            <div class="col-11 col-md-10 col-lg-9 mx-auto">
              <div class="logo">
                <img [src]="configInitial.logo.desktop" alt="logo">
              </div>
            </div>
          </div>
        </div>
        <div class="container my-auto pb-5 pt-4">
          <div class="row g-0">
            <div class="col-11 col-md-10 col-lg-9 col-xxl-8 mx-auto">
              <h4 class="mb-4">Facturación Electrónica</h4>
              <p class="text-muted" style="font-size: 13px; text-align: justify;">
                Para generar o consultar una factura es importante tener a la mano tu ticket.<br>
                <strong>Nota:</strong> Si ya has realizado tu factura en este portal y deseas
                precargar los datos que ingresaste en tu última factura, ingresa el
                <strong>RFC Receptor</strong> que utilizaste para realizarla.
              </p>
              <form [formGroup]="formTicket" (ngSubmit)="sendLogin()">
                <div class="row">
                  <div class="col-12">
                    <label class="form-label fw-600" style="font-size: 15px;">Número de ticket <span
                        class="fw-bold text-primary">*</span></label>
                    <div class="mb-3 icon-group icon-group-end">
                      <input type="text" class="form-control" formControlName="referencia" maxlength="35"
                        (paste)="REFERENCIA_ON_PASTE($event)" oninput="this.value = this.value.toUpperCase().trim()"
                        (keydown)="removeSpaces($event)">
                      <span class="icon-inside text-muted"><i class="fas fa-receipt"></i></span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-7 col-xxl-6">
                    <label class="form-label fw-600" style="font-size: 15px;">
                      Monto total del ticket <span class="fw-bold text-primary">*</span>
                    </label>
                    <div class="mb-3 icon-group icon-group-end">
                      <input type="text" [maxlength]="35" appNumberDecimalsLimit class="form-control"
                        formControlName="montoTotal">
                      <span class="icon-inside text-muted"><i class="fas fa-dollar-sign"></i></span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label class="form-label fw-600" style="font-size: 15px;">RFC Receptor</label>
                    <div class="mb-3 icon-group icon-group-end">
                      <input type="text" [maxlength]="35" class="form-control" formControlName="rfcReceptor"
                        (paste)="RFC_ON_PASTE($event)" maxlength="35"
                        oninput="this.value = this.value.toUpperCase().trim()" (keydown)="omit_special_char($event)">
                      <span class="icon-inside text-muted"><i class="far fa-user"></i></span>
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-12">
                    <div class="form-check">
                      <input (change)="isExtranjero($event)" class="form-check-input" type="checkbox">
                      <label class="form-check-label" for="remember-me">¿Factura en el extranjero?</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 d-lg-none">
                    <div class="d-grid mb-3 mt-2">
                      <button class="btn btn-primary" type="submit">
                        <i class="far fa-file-lines me-1"></i>
                        Iniciar facturación
                      </button>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="d-grid mb-5 mt-2">
                      <app-drawer-consulta-factura [formTicket]="formTicket"></app-drawer-consulta-factura>
                    </div>
                  </div>
                  <div class="col-lg-6 d-none d-lg-block">
                    <div class="d-grid mb-5 mt-2">
                      <button class="btn btn-primary" type="submit">
                        <i class="far fa-file-lines me-1"></i>
                        Iniciar facturación
                      </button>
                    </div>
                  </div>
                </div>
                <p class="text-2 text-muted text-center">
                  &copy; {{ anioActual }} Powered by NT Group | Todos los derechos reservados</p>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Login Form End -->

    </div>
  </div>
  }
  }
</div>